// Hover drawings show only what is under the pointer: on each hover update the
// tangent hover layers of layers with no hovered line are cleared (only lines get a
// tangent; the hovered ones redraw theirs).

/**
 * @param {{layer: object, hoverLayer: object}[]} pairs FeatureInfoControl's hover layers per layer
 * @param {{layer: object, line: boolean}[]} hovered the features under the pointer:
 *   their layer and whether they are a LineString
 * @returns {object[]} the hover layers to clear
 */
export function staleHoverLayers(pairs, hovered) {
  const layers = new Set(hovered.filter((h) => h.line).map((h) => h.layer));
  return pairs.filter((p) => !layers.has(p.layer)).map((p) => p.hoverLayer);
}
